const Typography ={
    h1: {},
    h2:{},
    h3:{
        color: "#004AAD", //Side headings
    },
    h4:{
    },
    h5:{
    },
    h6:{
    },
    subtitle1:{}
}
export default Typography